import CategoryPageView from "@/components/feature/CategoryPageView";

export default function TrendPage() {
  return <CategoryPageView categoryKey="trend" showTopics />;
}